"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.minutesToTimeString = exports.timeStringToMinutes = void 0;
function timeStringToMinutes(timeString) {
    var _a = timeString.split(":"), hours = _a[0], minutes = _a[1];
    return (parseInt(hours, 10) * 60) + parseInt(minutes, 10);
}
exports.timeStringToMinutes = timeStringToMinutes;
function minutesToTimeString(minutes) {
    var roundedMinutes = Math.round(minutes);
    var hoursString = Math.floor(roundedMinutes / 60).toString()
        .padStart(2, "0");
    var minutesString = (roundedMinutes % 60).toString().padStart(2, "0");
    return hoursString + ":" + minutesString;
}
exports.minutesToTimeString = minutesToTimeString;
//# sourceMappingURL=_TimeStringUtils.js.map